import {useQuery, useQueryClient} from "react-query";
import {getDeliveryDatesApi} from "../delivery/useDelivery";

export const useDeliveryDates = (zipCode?: string) => {
  const queryClient = useQueryClient();

  const startDate = new Date().toISOString().split('T')[0];
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 3 * 7);
  const formattedEndDate = endDate.toISOString().split('T')[0];

  const {data, isLoading} = useQuery(["delivery-dates", zipCode, startDate, formattedEndDate], async () => {
    
    return await getDeliveryDatesApi(zipCode, startDate, formattedEndDate);
  });

  return {
    data,
    isLoading,
    load: async (): Promise<string[]> =>
      queryClient.fetchQuery(["delivery-dates", zipCode, startDate, formattedEndDate]),
  };
};
